"use client";

type FiltersBarProps = {
  terms: string[];
  studentTypes: string[];
  selectedTerm: string;
  selectedStudentType: string;
  onTermChange: (value: string) => void;
  onStudentTypeChange: (value: string) => void;
};

export default function FiltersBar({
  terms,
  studentTypes,
  selectedTerm,
  selectedStudentType,
  onTermChange,
  onStudentTypeChange
}: FiltersBarProps) {
  return (
    <div className="flex flex-col gap-4 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm md:flex-row">
      <div className="flex flex-col gap-2">
        <label className="text-sm font-medium text-slate-700">Term</label>
        <select
          value={selectedTerm}
          onChange={(e) => onTermChange(e.target.value)}
          className="rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 outline-none focus:border-sky-500"
        >
          <option value="all">All terms</option>
          {terms.map((term) => (
            <option key={term} value={term}>
              {term}
            </option>
          ))}
        </select>
      </div>

      <div className="flex flex-col gap-2">
        <label className="text-sm font-medium text-slate-700">Student type</label>
        <select
          value={selectedStudentType}
          onChange={(e) => onStudentTypeChange(e.target.value)}
          className="rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 outline-none focus:border-sky-500"
        >
          <option value="all">All student types</option>
          {studentTypes.map((studentType) => (
            <option key={studentType} value={studentType}>
              {studentType}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
